import React from "react";
import { Text } from "..";
import { Wrapper, ToggleContainer, ModeBox, ModeInnerBox } from "./ModalCrop.style";

export const OrientationToggle = ({
    orientation,
    setOrientation,
    allowedOrientations,
    lockedAspectRatio,
}) => {
    return (
        <Wrapper marginTop="-10px" style={{
            opacity: lockedAspectRatio ? 0.5 : 1
        }}>
            <Text weight="bold" size="16px" align="left">
                Choose Orientation
            </Text>
            <Text weight="normal" size="14px" align="left">
                Instantly switch between landscape and portrait modes to match your design
                preferences.
            </Text>

            <ToggleContainer>
                {allowedOrientations.map((mode) => {
                    const isAllowed = allowedOrientations.includes(mode);
                    const isSelected = orientation === mode;

                    return (
                        <ModeBox
                            key={mode}
                            isAllowed={isAllowed}
                            isSelected={isSelected}
                            onClick={() => {
                                if (isAllowed) setOrientation(mode);
                            }}
                            style={{
                                pointerEvents: lockedAspectRatio ? "none" : "all"
                            }}
                        >
                            <ModeInnerBox mode={mode} isSelected={isSelected} />
                        </ModeBox>
                    );
                })}
            </ToggleContainer>
        </Wrapper>
    );
};
